import router from "../router/router"
import config from "../../config/config";
import { Operator_service } from "../services/Operator_service";
import { MessageBox, Loading } from 'element-ui';
const state = {
    operators: [],
    ungroup_operator: [],
    total: 0,
    prepare: null
};

const getters = {
    list_mobile: (state) => {
        return state.operators.filter(opr => opr.type_tag === 'mobile')
    },
    list_broadband: (state) => {
        return state.operators.filter(opr => opr.type_tag === 'broadband')
    },
    list_all: (state) => {
        return state.operators
    }
};

const actions = {
    async fetch_table({ commit }, filter) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Operator_service.getOperatorByType(filter)
        if(result.status === 200){
            setTimeout(function() { loadingInstance.close() }, 250)
            commit('CHANGE_DATA_TABLE',result.data)
            let total = result.data[0] ? result.data[0].total : 0
            commit('UPDATE_TOTAL', total)
        }else{
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    search({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let getData = Operator_service.getProviderByType(data.Connection_type);
        getData.subscribe({
            error: function(err) {
                setTimeout(function() { loadingInstance.close() }, 250)
                if (err.status === 230) {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    }).catch(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    });
                } else {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {}).catch(() => {});
                }
            },
            next: function(resource) {
                setTimeout(function() { loadingInstance.close() }, 250)
                state.operators = [];
                for (var i = 0; i < resource.length; i++) {
                    resource[i].provider_type = data.Connection_type
                    commit("CHANGE_DATA_TABLE", resource[i]);
                }
                commit("UPDATE_TOTAL", resource.length)       
             },
            complete: function(resource) {

            }
        })
    },

    add_operator({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let insertData = Operator_service.addProvider(data);
        insertData.subscribe({
            error: function(err) {
                setTimeout(function() { loadingInstance.close() }, 250)
                if (err.status === 230) {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    }).catch(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    });
                } else {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {}).catch(() => {});
                }
            },
            next: function(resource) {
                setTimeout(function() { loadingInstance.close() }, 250)
                MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'success'
                }).then(() => {
                    router.push({ name: 'ListOperator' })
                }).catch(() => {
                    router.push({ name: 'ListOperator' })
                });
            },
            complete: function(resource) {}
        })
    },
    remove_operator({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let go_delete = Operator_service.removeProvider(data);
        go_delete.subscribe({
            error: function(err) {
                setTimeout(function() { loadingInstance.close() }, 250)
                if (err.status === 230 || err.status === 225) {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    }).catch(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    });
                } else {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {}).catch(() => {});
                }
            },
            next: function(resource) {
                setTimeout(function() { loadingInstance.close() }, 250)
                MessageBox.confirm('ลบข้อมูลเรียบร้อยแล้ว', 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'success'
                }).then(() => {
                    //router.push({ name: 'ListOperator' })
                    commit('REMOVE_OPERATOR', data)
                    let total = state.total - 1
                    commit('UPDATE_TOTAL', total)
                }).catch(() => {});
            }
        });
    },
    edit_operator({ commit }, formData) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let go_edit = Operator_service.editProvider(formData);
        go_edit.subscribe({
            error: function(err) {
                setTimeout(function() { loadingInstance.close() }, 250)
                if (err.status === 230 || err.status === 225) {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    }).catch(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    });
                } else {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {}).catch(() => {});
                }
            },
            next: function(resource) {
                setTimeout(function() { loadingInstance.close() }, 250)
                MessageBox.confirm('แก้ไขข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'success'
                }).then(() => {
                    router.push({ name: 'ListOperator' })
                }).catch(() => {
                    router.push({ name: 'ListOperator' })
                });
            }
        });
    },
    async get_ungroup_operator({commit},data){
        let result = await Operator_service.getUngroupProvider()
        if(result.status === 200){
            commit('OPERATOR_LIST',result.data)
            commit('UPDATE_GROUP_OPREATOR', result.data)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {}).catch(() => {});
        }
    },
    async update_listoperator({commit}, rowdata){
        commit('PREPARE_EDIT',rowdata)
    }
};

const mutations = {
    CHANGE_DATA_TABLE(state, obj) {
        state.operators = []
        for(let data of obj){
            let type = (data.provider_type == 'mobile' ? 'โทรศัพท์เคลื่อนที่' : 'อินเทอร์เน็ตความเร็วสูงประจำที่');
            state.operators.push({
                service_type: type,
                type_tag: data.provider_type,
                name: data.provider_name,
                short_name: data.provider_short_name,
                brand_name: data.brand_name,
                logo: config.API_URL + data.provider_logo,
                logo_path: data.provider_logo,
                color: data.provider_color,
                info: data.id,
                status: true
            })
        }
    },
    REMOVE_OPERATOR(state, data) {
        var index = state.operators.findIndex(row => row.info == data)
        state.operators.splice(index, 1)
    },
    UPDATE_TOTAL(state, data){
        state.total = data
    },
    OPERATOR_LIST(state, data){
        state.ungroup_operator = data.result
    },
    UPDATE_GROUP_OPREATOR(state, data) {
        for (let i = 0; i < state.operators.length; i++) {
            if(state.operators[i].info == data.result[0].id) {
                state.operators[i].status = false
            }
        }
    },
    PREPARE_EDIT(state,data){
        state.prepare = data
    }
};

export const ListOperator = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};